import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f8a2ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Choze")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "v1.0", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Menu ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  Salir Cuenta ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "lHh Lpr lFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "glossy"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "menu",
                "aria-label": "Menu",
                onClick: _ctx.toggleLeftDrawer
              }, null, 8, ["onClick"]),
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.leftDrawerOpen,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
        "show-if-above": "",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, { header: "" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrOpciones, (item) => {
                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  key: item.id_Opcion,
                  clickable: "",
                  to: item.de_Path
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { avatar: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: item.nb_Icon
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.nb_Opcion), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_ripple]
                ])
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_q_btn, {
            class: "btnSubmit buttonCerrarCuenta",
            type: "button",
            color: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cerrarSession()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "logout" }),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}